import React from "react";
import { Table, Tag, Typography } from "antd";

const { Text } = Typography;

const columns = [
  {
    title: "Consecutivo",
    key: "consecutivo",
    render: (record) => (
      <Text type={record.factura_n ? undefined : "secondary"}>
        {record.factura_n?.consecutivo || "N/A"}
      </Text>
    ),
  },
  {
    title: "Cantidad",
    key: "cantidad",
    render: (record) => (
      <Text type={record.factura_n ? undefined : "secondary"}>
        {record.factura_n?.productos?.[0]?.cantidad || "N/A"}
      </Text>
    ),
  },
  {
    title: "Precio sin impuesto",
    key: "precio_sin_impuesto",
    render: (record) => (
      <Text type={record.factura_n ? undefined : "secondary"}>
        {record.factura_n
          ? `$${parseFloat(
              record.factura_n?.productos?.[0]?.producto?.preciosinimp || 0
            ).toFixed(2)}`
          : "N/A"}
      </Text>
    ),
  },
  {
    title: "Impuesto",
    key: "impuesto",
    render: (record) => (
      <Text type={record.factura_n ? undefined : "secondary"}>
        {record.factura_n
          ? `${parseFloat(
              record.factura_n?.productos?.[0]?.producto?.grupo?.impuesto || 0
            ).toFixed(2)}%`
          : "N/A"}
      </Text>
    ),
  },
  {
    title: "Total",
    key: "total",
    render: (record) => {
      if (!record.factura_n) return <Text type="secondary">N/A</Text>;
      const cantidad = record.factura_n?.productos?.[0]?.cantidad || 0;
      const precio = parseFloat(
        record.factura_n?.productos?.[0]?.producto?.preciosinimp || 0
      );
      const impuesto = parseFloat(
        record.factura_n?.productos?.[0]?.producto?.grupo?.impuesto || 0
      );
      const total = cantidad * precio * (1 + impuesto / 100);
      return `$${total.toFixed(2)}`;
    },
  },
  {
    title: "Producto",
    key: "productos",
    render: (record) =>
      record.factura_n ? (
        record.factura_n?.productos?.map((prod, idx) => (
          <Tag key={idx}>{prod.producto?.nombre}</Tag>
        ))
      ) : (
        <Text type="secondary">N/A</Text>
      ),
  },
];

const FacturaList = ({ data }) => (
  <Table
    dataSource={data}
    columns={columns}
    rowKey={(record) => record.factura_n?.consecutivo || Math.random()}
    pagination={false}
    locale={{
      emptyText: "No hay datos de facturas disponibles",
    }}
  />
);

export default FacturaList; 